module.exports = __webpack_public_path__ + "assets/images/icons/blue/icon_virus-green.svg?v=836d8d95";